import { isDefined } from "@clipboard-health/util-ts";
import { Stack } from "@mui/material";
import { type EmergencyCreditStatsCommon } from "@src/appV2/ClipboardScore/api/useGetClipboardScoreProfile";
import { CancellationCreditProgressBar } from "@src/appV2/redesign/EmergencyCredits/components/CancellationCreditProgressBar";

interface CreditProgressSectionProps {
  cancellationCreditStats: EmergencyCreditStatsCommon | undefined;
}

export function CreditProgressSection(props: CreditProgressSectionProps): JSX.Element | null {
  const { cancellationCreditStats } = props;

  if (!isDefined(cancellationCreditStats)) {
    return null;
  }

  return (
    <Stack sx={{ paddingX: 6, paddingY: 4 }}>
      <CancellationCreditProgressBar
        showShiftsProgress
        cancellationCreditStats={cancellationCreditStats}
      />
    </Stack>
  );
}
